import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahsmlt',
  templateUrl: './asahsmlt.component.html',
  styleUrls: ['./asahsmlt.component.scss']
})
export class AsahsmltComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
